import {useParams} from 'react-router-dom';

import {useCoreweaveIdQuery} from '../../generated/graphql';
import {useRampFlagIssuesObservability} from '../../util/rampFeatureFlags';

export const useRampFlagCoreweaveIssues = () => {
  const {entityName} = useParams<{
    entityName: string;
  }>();
  const ramp = useRampFlagIssuesObservability(entityName);
  const {data} = useCoreweaveIdQuery({
    variables: {entity: entityName},
  });
  const coreweaveId = data?.entity?.organization?.coreWeaveOrganizationId;
  return ramp && !!coreweaveId;
};
